/* projects/speaker-platform/src/app/organisms/seances-list/seances-list.component.scss */
.seanceslist {
  list-style: none;
  padding: 0;
}
.seanceslist__item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  text-align: right;
  border-bottom: 1px solid #818181;
  cursor: pointer;
}
.seanceslist__item:hover,
.seanceslist__item--selected {
  background-color: #FFED00;
}
.seanceslist__item__count {
  width: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
/*# sourceMappingURL=seances-list.component-TC24KMAY.css.map */
